import { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthWrapper } from '@weareopenr/authkit';

import { PrimaryButton, Typography, openrLogoGradient } from '@weareopenr/component-library';
import styles from './Welcome.module.scss';

const logSignInError = (error: unknown) => console.error('Failed to initiate sign in:', error);

const Welcome = () => {
  const { user, signIn } = useAuthWrapper();
  const hasInitiatedSignIn = useRef(false);

  useEffect(() => {
    document.title = 'Welcome';
  }, []);

  useEffect(() => {
    if (user || hasInitiatedSignIn.current) return;
    hasInitiatedSignIn.current = true;
    signIn().catch(logSignInError);
  }, [user, signIn]);

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src={openrLogoGradient} alt="Openr" className={styles.logo} />
        <Typography size="xlarge" weight="bold" className={styles.title}>
          Signing you in…
        </Typography>
        <PrimaryButton size="full-width" onClick={() => signIn().catch(logSignInError)}>
          Log in
        </PrimaryButton>
      </div>
    </div>
  );
};

export default Welcome;
